module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-imports-detail/master-imports-detail.component.scss
// module id = ./src/app/master/master-imports-detail/master-imports-detail.component.scss
// module chunks = main